// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aBck","label":"styles_label__MaT13"};